/* ============================================================
   HYPESOLE — Shopify bridge
   Load AFTER hypesole.js. Wires the Liquid-rendered DOM to the
   real Shopify Ajax API: /cart/add.js, /cart.js, /products/*.js
   ============================================================ */
(function () {
  'use strict';

  const $  = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.prototype.slice.call((r || document).querySelectorAll(s));
  const HS = window.HYPESOLE || (window.HYPESOLE = {});
  const toast = (a, b, c) => HS.toast ? HS.toast(a, b, c) : null;

  const money = cents => {
    const fmt = window.Shopify && Shopify.currency ? Shopify.currency.active : 'EGP';
    return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0 }) + ' ' + fmt;
  };

  /* ---------------------------------------------------------
     1. Internal card slider over Liquid product images
     --------------------------------------------------------- */
  function initCardSliders() {
    $$('.card').forEach(card => {
      const track = $('.card-track', card);
      if (!track) return;
      const cells = $$('.card-cell', track);
      const dots  = $$('.card-dots button', card);
      const label = $('.card-angle', card);
      const NAMES = ['LATERAL', 'FRONT', 'OUTSOLE', 'TOP'];
      let i = 0;

      const go = n => {
        i = (n + cells.length) % cells.length;
        track.style.transform = 'translateX(' + (i * -100) + '%)';
        dots.forEach((d, k) => d.classList.toggle('on', k === i));
        if (label) label.textContent = NAMES[i] || 'ANGLE ' + (i + 1);
      };
      dots.forEach((d, k) => d.addEventListener('click', e => { e.stopPropagation(); go(k); }));
      const next = $('.card-nav--next', card), prev = $('.card-nav--prev', card);
      next && next.addEventListener('click', e => { e.stopPropagation(); go(i + 1); });
      prev && prev.addEventListener('click', e => { e.stopPropagation(); go(i - 1); });

      /* Phones hide the arrows, so the angles are reachable by swipe instead. */
      if (cells.length > 1) {
        let sx = 0, sy = 0, tracking = false;
        track.addEventListener('touchstart', e => {
          tracking = true;
          sx = e.touches[0].clientX; sy = e.touches[0].clientY;
        }, { passive: true });
        track.addEventListener('touchend', e => {
          if (!tracking) return;
          tracking = false;
          const dx = e.changedTouches[0].clientX - sx;
          const dy = e.changedTouches[0].clientY - sy;
          /* ignore a vertical scroll that happens to start on the image */
          if (Math.abs(dx) < 34 || Math.abs(dx) < Math.abs(dy)) return;
          go(dx < 0 ? i + 1 : i - 1);
        }, { passive: true });
      }

      const fav = $('.card-fav', card);
      fav && fav.addEventListener('click', function (e) {
        e.stopPropagation();
        this.classList.toggle('on');
        const on = this.classList.contains('on');
        this.innerHTML = '<i class="fa-' + (on ? 'solid' : 'regular') + ' fa-heart"></i>';
        toast(on ? 'Added to wishlist' : 'Removed from wishlist', $('.card-title', card).textContent.trim());
      });
    });
  }

  /* ---------------------------------------------------------
     2. Add to cart — real AJAX, with the bounce micro-interaction
     --------------------------------------------------------- */
  async function addToCart(variantId, qty, btn) {
    if (btn) { btn.classList.remove('bump'); void btn.offsetWidth; btn.classList.add('bump'); }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
      });
      if (!res.ok) throw new Error((await res.json()).description || 'Could not add to cart');
      const data = await res.json();
      const line = data.items ? data.items[0] : data;
      toast('Added to cart', line.product_title + '  ·  ' + line.variant_title, 'fa-bag-shopping');
      await refreshCart();
      openCart();
    } catch (err) {
      toast('Could not add to cart', err.message, 'fa-triangle-exclamation');
    }
  }

  document.addEventListener('click', e => {
    const atc = e.target.closest('[data-atc]');
    if (atc) {
      e.preventDefault();
      addToCart(atc.dataset.atc, 1, atc);
      return;
    }
    /* Buy Now: bypass the cart, straight to secure checkout */
    const buy = e.target.closest('[data-buynow]');
    if (buy) {
      const ov = $('#checkout-ov');
      if (ov) {
        const card = buy.closest('.card');
        const t = $('#co-item');
        if (t && card) t.textContent = $('.card-title', card).textContent.trim();
        ov.classList.add('on');
      }
      /* let the href do the navigation — /cart/<variant>:1?checkout */
    }
  });

  /* ---------------------------------------------------------
     3. Cart drawer — rendered from /cart.js
     --------------------------------------------------------- */
  const FREE_SHIP = (HS.freeShippingThreshold || 300000); /* cents */

  async function refreshCart() {
    const body = $('#cart-body');
    if (!body) return;
    const cart = await (await fetch('/cart.js')).json();

    const cc = $('#cart-count');
    if (cc) {
      cc.textContent = cart.item_count;
      cc.classList.remove('pop'); void cc.offsetWidth; cc.classList.add('pop');
    }
    const sub = $('#cart-sub'), tot = $('#cart-total');
    if (sub) sub.textContent = money(cart.total_price);
    if (tot) tot.textContent = money(cart.total_price);

    const bar = $('#ship-bar'), txt = $('#ship-txt');
    if (bar) bar.style.width = Math.min(100, cart.total_price / FREE_SHIP * 100) + '%';
    if (txt) txt.innerHTML = cart.total_price >= FREE_SHIP
      ? '<i class="fa-solid fa-truck-fast"></i> Nice! You unlocked free express shipping'
      : 'Add <b>' + money(FREE_SHIP - cart.total_price) + '</b> more for free express shipping';

    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty"><i class="fa-solid fa-bag-shopping"></i>Your cart is empty — start with the hottest drop</div>';
      return;
    }
    body.innerHTML = cart.items.map(it =>
      '<div class="citem">' +
        '<div class="citem-media">' +
          (it.image ? '<img src="' + it.image.replace(/(\.[^.]*)$/, '_160x$1') + '" alt="">' : '') +
        '</div>' +
        '<div><b>' + it.product_title + '</b>' +
          '<small>' + (it.variant_title || '') + '  ·  x' + it.quantity + '</small>' +
          '<div class="pz">' + money(it.final_line_price) + '</div></div>' +
        '<button class="rm" type="button" data-remove="' + it.key + '" aria-label="Remove">' +
          '<i class="fa-solid fa-xmark"></i></button>' +
      '</div>'
    ).join('');
  }

  document.addEventListener('click', async e => {
    const rm = e.target.closest('[data-remove]');
    if (!rm) return;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: rm.dataset.remove, quantity: 0 })
    });
    refreshCart();
  });

  const openCart  = () => { $('#cart') && $('#cart').classList.add('on'); $('#cart-bg') && $('#cart-bg').classList.add('on'); document.body.classList.add('is-locked'); };
  const closeCart = () => { $('#cart') && $('#cart').classList.remove('on'); $('#cart-bg') && $('#cart-bg').classList.remove('on'); document.body.classList.remove('is-locked'); };

  /* ---------------------------------------------------------
     4. Quick View from /products/<handle>.js
     --------------------------------------------------------- */
  let qvProduct = null, qvVariant = null;

  async function openQuick(handle) {
    const sheet = $('#quickview'); if (!sheet) return;
    const p = await (await fetch('/products/' + handle + '.js')).json();
    qvProduct = p; qvVariant = p.variants.find(v => v.available) || p.variants[0];

    $('#qv-brand').textContent = (p.vendor || '').toUpperCase();
    $('#qv-title').textContent = p.title;
    $('#qv-desc').innerHTML = p.description;
    $('#qv-price').innerHTML = '<b>' + money(p.price) + '</b>' +
      (p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '');

    /* size buttons from the Size option */
    const sizeIdx = p.options.findIndex(o => /size/i.test(o.name || o));
    const box = $('#qv-sizes'); box.innerHTML = '';
    if (sizeIdx > -1) {
      const seen = {};
      p.variants.forEach(v => {
        const val = v.options[sizeIdx];
        if (seen[val]) return; seen[val] = 1;
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'size'; b.textContent = val;
        b.disabled = !v.available;
        b.addEventListener('click', () => {
          $$('.size', box).forEach(x => x.classList.remove('on'));
          b.classList.add('on'); qvVariant = v;
        });
        box.appendChild(b);
      });
    }

    /* image gallery + thumbs */
    const zoom = $('#qv-zoom'), thumbs = $('#qv-thumbs');
    zoom.classList.remove('zoomed'); thumbs.innerHTML = '';
    const show = i => {
      zoom.innerHTML = '<img src="' + p.images[i] + '" alt="' + p.title + '">';
      $$('button', thumbs).forEach((b, k) => b.classList.toggle('on', k === i));
    };
    p.images.slice(0, 4).forEach((src, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.innerHTML = '<img src="' + src.replace(/(\.[^.]*)$/, '_120x$1') + '" alt="">';
      b.addEventListener('click', () => show(i));
      thumbs.appendChild(b);
    });
    if (p.images.length) show(0);

    sheet.classList.add('on');
    document.body.classList.add('is-locked');
  }

  document.addEventListener('click', e => {
    const qv = e.target.closest('[data-quickview]');
    if (qv) { e.preventDefault(); openQuick(qv.dataset.quickview); }
  });

  /* ---------------------------------------------------------
     5. Product page — gallery, 360 toggle, variant picker
     --------------------------------------------------------- */
  function initPDP() {
    const stage = $('#pdp-stage'); if (!stage) return;
    const shots  = $$('.pdp-shot', stage);
    const thumbs = $$('#pdp-thumbs button');
    thumbs.forEach((b, i) => b.addEventListener('click', () => {
      shots.forEach((s, k) => s.classList.toggle('on', k === i));
      thumbs.forEach((t, k) => t.classList.toggle('on', k === i));
    }));

    /* 360 toggle */
    const toggle = $('#pdp-360-toggle'), rig = $('#spin360');
    if (toggle && rig) {
      toggle.addEventListener('click', () => {
        const showing = rig.hasAttribute('hidden');
        if (showing) {
          rig.removeAttribute('hidden');
          $('#pdp-shots').style.visibility = 'hidden';
          toggle.classList.add('on');
          toggle.querySelector('span').textContent = 'View photos';
          window.dispatchEvent(new Event('resize'));
        } else {
          rig.setAttribute('hidden', '');
          $('#pdp-shots').style.visibility = '';
          toggle.classList.remove('on');
          toggle.querySelector('span').textContent = 'View in 360°';
        }
      });
    }

    /* variant picker: option buttons → matching variant id */
    const product = HS.product;
    if (!product) return;
    const groups = $$('.pdp-form .sizes');
    const chosen = product.options.map((_, i) =>
      (product.variants.find(v => v.available) || product.variants[0]).options[i]);

    groups.forEach(group => {
      const idx = Number(group.dataset.optionIndex);
      $$('.size', group).forEach(btn => btn.addEventListener('click', () => {
        $$('.size', group).forEach(x => x.classList.remove('on'));
        btn.classList.add('on');
        chosen[idx] = btn.dataset.optionValue;
        const match = product.variants.find(v => v.options.every((o, i) => o === chosen[i]));
        if (!match) return;
        $('#pdp-variant').value = match.id;
        const buy = $('#pdp-buynow');
        if (buy) {
          buy.href = (HS.routes ? HS.routes.cart : '/cart') + '/' + match.id + ':1?checkout';
          buy.dataset.buynow = match.id;
        }
      }));
    });
  }

  /* ---------------------------------------------------------
     6. Predictive search
     --------------------------------------------------------- */
  function initSearch() {
    const modal = $('#search-modal'), input = $('#search-input'), out = $('#search-results');
    if (!modal || !input) return;
    const open  = () => { modal.classList.add('on'); document.body.classList.add('is-locked'); setTimeout(() => input.focus(), 120); };
    const close = () => { modal.classList.remove('on'); document.body.classList.remove('is-locked'); };

    $$('[data-open-search], .ico-btn[aria-label="Search"]').forEach(b =>
      b.addEventListener('click', e => { e.preventDefault(); open(); }));
    $('#search-close') && $('#search-close').addEventListener('click', close);
    $('#search-bg') && $('#search-bg').addEventListener('click', close);
    addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

    const baseHTML = out.innerHTML;
    let timer;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = baseHTML; return; }
      timer = setTimeout(async () => {
        const url = (HS.routes && HS.routes.predictiveSearch ? HS.routes.predictiveSearch : '/search/suggest')
          + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
        try {
          const res = await fetch(url.replace('&section_id=predictive-search', '') + '&resources[options][unavailable_products]=last', {
            headers: { 'Accept': 'application/json' }
          });
          const data = await res.json();
          const items = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!items.length) {
            out.innerHTML = '<p class="search-hint">No matches for “' + q + '”</p>';
            return;
          }
          out.innerHTML = '<p class="search-hint">Products</p>' + items.map(p =>
            '<a class="sr-item" href="' + p.url + '">' +
              (p.image ? '<img src="' + p.image + '" alt="">' : '') +
              '<div><b>' + p.title + '</b><span>' + (p.vendor || '') + '</span></div>' +
              '<span class="pz">' + (p.price ? money(Number(p.price)) : '') + '</span>' +
            '</a>'
          ).join('');
        } catch (err) {
          out.innerHTML = '<p class="search-hint">Search is unavailable right now</p>';
        }
      }, 220);
    });
  }

  /* ---------------------------------------------------------
     7. Sticky buy bar + live sale proof (reads the rendered grid)
     --------------------------------------------------------- */
  function initStickyBar() {
    const bar = $('#sticky-bar'); if (!bar) return;
    addEventListener('scroll', () => {
      const nearEnd = scrollY + innerHeight > document.documentElement.scrollHeight - 420;
      bar.classList.toggle('on', scrollY > 720 && !nearEnd);
    }, { passive: true });
  }

  const CITIES = ['Cairo', 'Alexandria', 'Giza', 'Dubai', 'Riyadh', 'Doha', 'Kuwait City', 'Amman', 'Jeddah', 'Casablanca'];
  function liveSaleProof() {
    const zone = $('#toast-zone'); if (!zone) return;
    const cards = $$('.card .card-title');
    if (!cards.length) return;
    (function fire() {
      setTimeout(() => {
        const title = cards[Math.floor(Math.random() * cards.length)].textContent.trim();
        const city  = CITIES[Math.floor(Math.random() * CITIES.length)];
        const mins  = 2 + Math.floor(Math.random() * 26);
        const t = document.createElement('div');
        t.className = 'toast toast--buy';
        t.innerHTML = '<i class="fa-solid fa-bag-shopping"></i><div>' +
          '<b>Someone in ' + city + ' just bought</b>' +
          '<small>' + title + '  ·  ' + mins + ' min ago</small></div>';
        zone.appendChild(t);
        setTimeout(() => { t.classList.add('out'); setTimeout(() => t.remove(), 400); }, 4600);
        fire();
      }, 12000 + Math.random() * 16000);
    })();
  }

  /* ---------------------------------------------------------
     8. Sample-content buttons — explain instead of failing
     --------------------------------------------------------- */
  document.addEventListener('click', e => {
    const demo = e.target.closest('[data-demo]');
    if (!demo) return;
    e.preventDefault();
    toast('Sample product', 'Connect a collection in Customize to make “' + demo.dataset.demo + '” live', 'fa-circle-info');
  });

  /* ---------------------------------------------------------
     9. Wiring
     --------------------------------------------------------- */
  function boot() {
    initCardSliders();
    initPDP();
    initSearch();
    initStickyBar();
    liveSaleProof();
    refreshCart();

    const oc = $('#open-cart');
    oc && oc.addEventListener('click', e => { e.preventDefault(); openCart(); });
    $('#close-cart') && $('#close-cart').addEventListener('click', closeCart);
    $('#cart-bg') && $('#cart-bg').addEventListener('click', closeCart);

    $('#qv-add') && $('#qv-add').addEventListener('click', function () {
      if (!qvVariant) return;
      addToCart(qvVariant.id, 1, this);
      $('#quickview').classList.remove('on');
    });
    $('#qv-buy') && $('#qv-buy').addEventListener('click', () => {
      if (!qvVariant) return;
      window.location.href = '/cart/' + qvVariant.id + ':1?checkout';
    });
    $('#cart-checkout') && $('#cart-checkout').addEventListener('click', () => { window.location.href = '/checkout'; });

    /* newsletter forms post to Shopify's customer form when present */
    document.addEventListener('submit', e => {
      const f = e.target.closest('.cta-form');
      if (f && !f.action) {
        e.preventDefault(); f.reset();
        toast('You are on the list', 'Drop alerts will hit your inbox first', 'fa-envelope');
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
